export type WaterMarkWarningFormat = 'bulk' | 'single';

export const singleWatermarkEdit = 'Manual watermark changes are rare.';
export const bulkWatermarkEdit = 'Watermark value being changed.';
export const isWatermarkChangeIntentionalMessage = 'Please make sure this is intentional before saving.';
export const watermarkInfoMessage =
    'Moving the watermark value (ID or date) too far in either direction can cause gaps in data or unnecessary processing overhead. It is also important not to change from ID to date or vice versa.';
